<template>
  <tr>
    <td class="">{{ product.name }}</td>
    <td class="">{{ discountDaysLabel }}</td>
    <td class="">{{ product.dateEffective | dateFormatOrDefault('-') }}</td>
    <td class="">{{ product.endDate | dateFormatOrDefault('-') }}</td>
    <td class="">{{ product.entryStationName }}</td>
    <td class="">{{ product.exitStationName }}</td>
    <td class="" v-html="regionsLabel"/>
    <td class="">{{ $n(product.price, 'currency') }}</td>
  </tr>
</template>
<script>
import { dateFormatOrDefault } from '../../filters/date-format'

export default {
  name: 'RorProductListItem',
  filters: {
    dateFormatOrDefault
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    discountDaysLabel: function () {
      if (this.product.discountDayNames.length === 7) {
        return 'Volledig'
      }
      return this.product.discountDayNames.map((name) => name.substring(0, 2)).join('. ')
    },
    regionsLabel: function () {
      return this.product.regionNames.join('<br>')
    }
  },
  methods: {}
}

</script>



// WEBPACK FOOTER //
// src/components/rorProducts/RorProductListItem.vue